import {
    AdditiveBlending,
    AmbientLight,
    PointLight,
    SpotLight,
    Sprite,
    SpriteMaterial,
    TextureLoader,
    checkMobile
} from 'da-three';
import EventDispatcher from './../service/EventDispatcher.js';

export default class LightManager {     
    constructor(mediator,config,sceneMan) {
        this.config = config;
        this.mediator = mediator;
        this.sceneMan = sceneMan;
        this.flyingLightOn = this.config.features.useFloatingLight.default;
        this.dispatcher = new EventDispatcher();
        this.dispatcher.setEventTypes([
            'setFlyingLight'
        ]);
        
        this.lightSetups = [];
        this.flyingLight = [];
        
        this.createLightSetups(this.config.lightSetups);
        this.loadLights();
        
        this.mediator.addEventListener('beforeRender',this.moveFlyingLight.bind(this));
    }



    createLightSetups(edLightSetups) {
        let lsAmount = edLightSetups.length;
        for (let i=0;i<lsAmount;i++){
            let lightSetup = {
                name: edLightSetups[i].name,
                lights: []
            };

            let lAmount = edLightSetups[i].lights.length;
            for(let j=0;j<lAmount;j++){
                let tmpL = edLightSetups[i].lights[j];
                let light;
                switch(tmpL.type){
                    case 'Ambient':
                        light = new AmbientLight(parseInt((''+tmpL.color).replace("#", "0x"),16));
                        break;
                    case 'Point':
                        light = new PointLight(parseInt((''+tmpL.color).replace("#", "0x"),16));
                        light.position.set(tmpL.pos.x,tmpL.pos.y,tmpL.pos.z);
                        if (tmpL.castShadow && !checkMobile()) {
                            light.castShadow            = tmpL.castShadow;
                            light.shadow.bias           = -0.005;
                            light.shadow.camera.near    = tmpL.shadowNear;
                            light.shadow.camera.far     = tmpL.shadowFar;
                            light.shadow.mapSize.width  = tmpL.shadowMap;
                            light.shadow.mapSize.height = tmpL.shadowMap;
                            light.shadow.radius         = 1.2;
                        }
                        break;
                    case 'Spot':
                    default:
                        light = new SpotLight(parseInt((''+tmpL.color).replace("#", "0x"),16));
                        light.position.set(tmpL.pos.x,tmpL.pos.y,tmpL.pos.z);
                        light.target.position.set(tmpL.dir.x,tmpL.dir.y,tmpL.dir.z);
                        if (tmpL.castShadow && !checkMobile()){
                            light.castShadow            = tmpL.castShadow;
                            light.hasShadow             = tmpL.hasShadow;
                            //light.onlyShadow          = tmpL.onlyshadow;
                            light.power                 = tmpL.shadowDarkness;
                            light.shadow.bias           = 0.1;
                            light.shadow.camera.near    = tmpL.shadowNear;
                            light.shadow.camera.far     = tmpL.shadowFar;
                            light.shadow.mapSize.width  = tmpL.shadowMap;
                            light.shadow.mapSize.height = tmpL.shadowMap;
                        }
                        break;
                }
                light.intensity = tmpL.intensity;
                lightSetup.lights.push(light);
            }

            this.lightSetups.push(lightSetup);
        }
    }
    
    
    
    loadLights() {
        if (this.config.tech.debug) console.log('DEBUG ===== loading lights...');

        //Add lights of active setup to scene
        let lsLength = this.lightSetups.length;
        for (let i=0;i<lsLength;i++){
            if (i === 0){
                this.activeLightSetup = this.lightSetups[i].name;

                //Only activate first setup if flying light and dynamic sky are turned off
                if (this.flyingLightOn === false){
                    let lslLength = this.lightSetups[i].lights.length;
                    for (let j=0;j<lslLength;j++){
                        this.sceneMan.scene.add(this.lightSetups[i].lights[j]);
                    }
                }
            }
        }
        if (this.config.tech.debug) console.log('DEBUG ===== lights done');
    }
    
    
    
    moveFlyingLight(){
        if (this.flyingLightOn){
            let flx = Math.sin(new Date().getTime() * .0012)*6;
            let fly = Math.cos(new Date().getTime() * .0005)*3;
            let flz = Math.cos(new Date().getTime() * .001)*6;

            let flLength = this.flyingLight.length;
            for (let i=0;i < flLength;i++){
                this.flyingLight[i].position.x = flx;
                this.flyingLight[i].position.y = fly;
                this.flyingLight[i].position.z = flz;
            }
        }
    }
    
    
    
    switchLightSetupTo(value){
        this.activeLightSetup = value;

        if (!this.flyingLightOn){
            if (this.config.tech.debug) console.log('DEBUG ==== Switch light to: '+value);
            let lsLength = this.lightSetups.length;
            for (let i=0;i<lsLength;i++){
                let lightSetting = (this.lightSetups[i].name === value);
                if (this.config.tech.debug) console.log('DEBUG ==== Light setting: '+lightSetting);

                let lslLength = this.lightSetups[i].lights.length;
                for (let j=0;j<lslLength;j++){
                    if (lightSetting){
                        this.sceneMan.scene.add(this.lightSetups[i].lights[j]);
                    }else{
                        this.sceneMan.scene.remove(this.lightSetups[i].lights[j]);
                    }
                }
            }
        }
    }
    
    
    
    toggleFlyingLight(switchSetup){
        let toggleLightSetup = switchSetup!==undefined?switchSetup:true;
        this.flyingLightOn = !this.flyingLightOn;
        this.dispatcher.dispatch('setFylingLight',this.flyingLightOn);
        
        if (this.flyingLightOn){
            if (this.config.features.useSkyBox.active){
                this.sceneMan.setSkyBoxBrightness(0.1);
            }else{
                document.getElementById('darkness').style.opacity = 0.9;
            }

            let lsLength = this.lightSetups.length;
            for (let i=0;i<lsLength;i++){
                if (this.lightSetups[i].name === this.activeLightSetup){
                    for (let j=0;j<this.lightSetups[i].lights.length;j++){
                        this.sceneMan.scene.remove(this.lightSetups[i].lights[j]);
                    }
                    break;
                }
            }
            //let bbMax = new Vector2(0,0).copy(this.group.boundingBox.max);
            //let bbMin = new Vector2(0,0).copy(this.group.boundingBox.min);
            //let diamVec = bbMax.sub(bbMin);

            let light = new PointLight(0xffffff,1,200);
            light.position.set(0, 0, 0);
            light.castShadow = true;
            light.shadow.bias = -0.005;
            light.shadow.camera.near = 0.2;
            light.shadow.camera.far = 15;
            light.shadow.mapSize.width = 2048;
            light.shadow.mapSize.height = 2048;
            //light.diameter = diamVec.length() * this.config.object.scale * 2.5;
            this.sceneMan.scene.add(light);
            this.flyingLight.push(light);
            
            let texLoader = new TextureLoader();
            texLoader.crossOrigin = ' ';
            var spriteMaterial = new SpriteMaterial({ 
                map: texLoader.load( this.config.project.basedir+this.config.project.static+'textures/highlight/glowTrans.png' ), 
                color: 0xffe7b0, 
                transparent: false, 
                blending: AdditiveBlending

            });
            let sprite1 = new Sprite( spriteMaterial );
            sprite1.scale.set(0.7, 0.7, 0.7);
            sprite1.position.set(0,0,0);
            this.sceneMan.scene.add(sprite1);
            this.flyingLight.push(sprite1);
        }else{	
            for (let i=0;i<this.flyingLight.length;i++){
                this.sceneMan.scene.remove(this.flyingLight[i]);
            }
            this.flyingLight = [];
            if (toggleLightSetup){
                this.switchLightSetupTo(this.activeLightSetup);
            }
            
            if (this.config.features.useSkyBox.active){
                this.sceneMan.setSkyBoxBrightness(1);
            }else{
                document.getElementById('darkness').style.opacity = 0;
            }
        }	
    }
};


// WEBPACK FOOTER //
// ./src/js/studio/manager/LightManager.js